<script setup lang="ts">
import {computed} from 'vue';
import {useRequiredTrueRule} from '@/ts/composables/pure/use-input-rules';

const props = defineProps<{
  optional?: boolean;
}>();

const model = defineModel<boolean>();
const requiredTrueRule = useRequiredTrueRule();

const rules = computed(() => props.optional ? [] : [requiredTrueRule]);

</script>
<template>
  <q-field v-model="model" :rules="rules" borderless dense>
    <q-checkbox v-model="model" dense>
      <slot name="label">
        <slot/>
      </slot>
    </q-checkbox>
  </q-field>
</template>
